import {
    faEnvelope,
    faEnvelopeOpen,
    faMessage,
    faMessageSlash,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';
import { ActivityItem as ActivityItemType } from 'types/domain';

const SubscriptionActivity = ({ item }: { item: ActivityItemType }) => {
    const [channel, action] = item.type.split('.');
    const isSms = channel === 'sms';
    const isUnsubscribed = action === 'unsubscribed';

    const actionText = isUnsubscribed ? 'Unsubscribed from' : 'Subscribed to';
    const channelName = isSms ? 'text messages' : 'emails';
    const bgColor = isUnsubscribed ? 'bg-red-50' : 'bg-green-50';
    const textColor = isUnsubscribed ? 'text-red-500' : 'text-green-500';

    return (
        <ActivityItem.Root>
            <ActivityItem.Trigger disabled>
                <ActivityItem.Icon className={bgColor}>
                    {isSms ? (
                        <SmsIcon isUnsubscribed={isUnsubscribed} className={textColor} />
                    ) : (
                        <EmailIcon isUnsubscribed={isUnsubscribed} className={textColor} />
                    )}
                </ActivityItem.Icon>
                <p>
                    {actionText} {channelName}
                </p>
            </ActivityItem.Trigger>
        </ActivityItem.Root>
    );
};

const EmailIcon = ({
    isUnsubscribed,
    className,
}: {
    isUnsubscribed: boolean;
    className: string;
}) => <FontAwesomeIcon icon={isUnsubscribed ? faEnvelope : faEnvelopeOpen} className={className} />;

const SmsIcon = ({ isUnsubscribed, className }: { isUnsubscribed: boolean; className: string }) => (
    <FontAwesomeIcon icon={isUnsubscribed ? faMessageSlash : faMessage} className={className} />
);

export { SubscriptionActivity };
